import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Header from "./Header";
import SideNav from "./SideNav";
import Login from "../loginPage/Login";
import VehicleEntries from "../Home/VehicleEntries";
import VehicleData from '../VehicleData/VehicleData';
import Cameras from '../Cameras/Cameras';
import Settings from '../Settings/Settings';
import Users from '../Users/Users'
import { useSelector } from "react-redux";
import ToastContainer from "../../components/Common/ToastContainer";



const Layout = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const loggedIn = useSelector((state) => state.auth.loggedIn);
  const [showBoombarrierModal, setShowBoombarrierModal] = useState(false);
  
  return (
    <div className="">
      <Header showBoombarrierModal={showBoombarrierModal} setShowBoombarrierModal={setShowBoombarrierModal} />
      <div className={`flex ${'pt-0'}`}>
        <SideNav />
        <div className={`flex-grow pr-3 pt-0`}>
          <div className={`bg-[#F9F9F7] rounded-xl h-screen_h_90 ${' pt-0'}`}>
            <Routes>
              <Route path="/" element={<VehicleEntries showBoombarrierModal={showBoombarrierModal} />} />
              <Route path="/vehicle-data" element={<VehicleData />} />
              <Route path="/cameras" element={<Cameras />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/users" element={<Users />} />
            </Routes>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Layout;